import { type CSSProperties, type ReactNode } from 'react';

import IconButton from '@atlaskit/button/icon/button';

import CloseIcon from '@atlaskit/icon/core/cross';

import { Box } from '@atlaskit/primitives/box';

import { xcss } from '@atlaskit/primitives/xcss/xcss';

const checklistShellStyles = xcss({
	position: 'relative',
});

const checklistContainerStyles = xcss({
	backgroundColor: 'elevation.surface',
	borderColor: 'color.border.bold',
	borderRadius: 'radius.small',
	borderTopLeftRadius: '0',
	borderTopRightRadius: '0',
	borderStyle: 'solid',
	borderWidth: 'border.width',
	borderBlockStartWidth: '0',
	overflow: 'hidden',
});

const checklistContainerStyle = {
	borderColor: 'var(--activation-checklist-border-color, var(--ds-border-bold, #172B4D))',
} satisfies CSSProperties;

const dismissFooterStyles = xcss({
	alignItems: 'center',
	backgroundColor: 'elevation.surface',
	borderColor: 'color.border.bold',
	borderRadius: 'radius.full',
	borderStyle: 'solid',
	borderWidth: 'border.width',
	display: 'flex',
	justifyContent: 'center',
	position: 'absolute',
});

const dismissFooterStyle = {
	borderColor: 'var(--activation-checklist-border-color, var(--ds-border-bold, #172B4D))',
	height: '32px',
	insetBlockEnd: '-16px',
	insetInlineEnd: '-16px',
	width: '32px',
	zIndex: 1,
} satisfies CSSProperties;

const DismissChecklistButton = ({ label, onClick }: { label: string; onClick: () => void }) => (
	<Box style={dismissFooterStyle} xcss={dismissFooterStyles}>
		<IconButton
			appearance="subtle"
			icon={(iconProps) => <CloseIcon {...iconProps} size="small" />}
			label={label}
			onClick={onClick}
			spacing="compact"
		/>
	</Box>
);

export const ActivationChecklistShell = ({
	children,
	dismissLabel,
	onDismiss,
}: {
	children: ReactNode;
	dismissLabel: string;
	onDismiss: () => void;
}): JSX.Element => (
	<Box data-activation-checklist-shell xcss={checklistShellStyles}>
		<Box style={checklistContainerStyle} xcss={checklistContainerStyles}>
			{children}
		</Box>
		<DismissChecklistButton label={dismissLabel} onClick={onDismiss} />
	</Box>
);
